@if (view.site && view.site.profile && view.site.profile.pages) {
    @switch (view.site.profile.pages.onboarding) {
        @case (1) {
            <app-onboarding-type01 class="w-full"></app-onboarding-type01>
            }
        @case (2) {
            }
    }
}